import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { AsyncStatus } from '@/shared/types/asyncState';

import type { FlowLogsDrawerContext, NegociacaoFlowLogs } from '../../types/flowLogs';
import { fetchFlowLogs } from './actions';

interface FlowLogsState {
  open: boolean;
  negociacaoCasoId: string | null;
  negociacaoLabel: string | null;
  data: NegociacaoFlowLogs | null;
  loading: boolean;
  error: string | null;
  status: AsyncStatus;
}

const initialState: FlowLogsState = {
  open: false,
  negociacaoCasoId: null,
  negociacaoLabel: null,
  data: null,
  loading: false,
  error: null,
  status: 'idle',
};

const flowLogsSlice = createSlice({
  name: 'flowLogs',
  initialState,
  reducers: {
    openDrawer: (_state, action: PayloadAction<FlowLogsDrawerContext>) => ({
      ...initialState,
      open: true,
      ...action.payload,
    }),
    closeDrawer: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFlowLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = 'loading';
      })
      .addCase(fetchFlowLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.status = 'success';
      })
      .addCase(fetchFlowLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Erro desconhecido';
        state.status = 'error';
      });
  },
});

export const { openDrawer, closeDrawer } = flowLogsSlice.actions;
export const flowLogsReducer = flowLogsSlice.reducer;
